module.exports = __webpack_public_path__ + "static/main-illustration-beb25501b4904eb763b952c566bafdf3.svg";